var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublished = function SvgPublished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D6D7",
    fillRule: "evenodd",
    d: "M14 3.993A3.993 3.993 0 0 0 10.007 0H3.993A3.993 3.993 0 0 0 0 3.993v6.014A3.993 3.993 0 0 0 3.993 14h6.014A3.993 3.993 0 0 0 14 10.007zm-3.764 1.528q0 1.23-.806 1.886-.805.655-2.293.655H6.32V11H5.037V3.147h2.26q1.473 0 2.206.602t.733 1.772M6.32 6.982h.682q.99 0 1.45-.343.463-.345.463-1.075 0-.675-.414-1.01-.413-.332-1.29-.332h-.89z"
  })));
};
export default SvgPublished;